<template>
  <div>
    <!-- ADD NEW SNMP COMMUNITY START -->
    <section name="add-community">
      <molecule-modal-dialog
        modalId="credential__add-community"
        :isTextCenter="true"
        textTitle="Add New SNMP Community"
        buttonTextLeft="Add Community"
        :isSlotBody="true"
        :isDisableButtonLeft="isDisableButtonAddCommunity"
        @clickButtonLeft="clickAddCommunity"
        @clickButtonRight="clickCancelAddCommunity"
      >
        <template #body>
          <div class="w-100 p-2">
            <div class="row">
              <div class="col-8">
                <atom-input
                  v-model="addCommunity.name"
                  title="SNMP Name"
                  placeholder="SNMP Name"
                  :isAsterisk="true"
                  :isError="isErrorCommunityInput.name"
                  errorMessage="Please enter name"
                ></atom-input>
              </div>

              <div class="col-4 pl-1">
                <atom-input
                  v-model="addCommunity.port"
                  title="Port"
                  placeholder="Port"
                  :isAsterisk="true"
                  :isError="isErrorCommunityInput.port"
                  :errorMessage="`${
                    !addCommunity.port ? 'Port require' : 'Port invalid'
                  }`"
                  type="number"
                ></atom-input>
              </div>
            </div>

            <atom-text-area
              v-model="addCommunity.description"
              title="Description"
              placeholder="SNMP Description"
              :rows="3"
              class="mt-1"
            ></atom-text-area>

            <atom-input
              v-model="addCommunity.communityString"
              title="Community String"
              placeholder="Community String"
              :isAsterisk="true"
              :isError="isErrorCommunityInput.communityString"
              errorMessage="Please enter community string"
              class="mt-1"
            ></atom-input>
          </div>
        </template>
      </molecule-modal-dialog>

      <section name="modal-confirm-add-community">
        <molecule-modal-dialog
          modalId="credential__confirm-add-community"
          :isTextCenter="true"
          :textTitle="`Do you want to add\n“${addCommunity.name}” ?`"
          buttonTextLeft="Confirm"
          @clickButtonLeft="clickConfirmAddCommunity"
          @clickButtonRight="clickBackToModalAddCommunity"
        ></molecule-modal-dialog>
        <molecule-modal-dialog
          modalId="credential__confirm-cancel-add-community"
          :isTextCenter="true"
          :textTitle="`Do you want to leave\nwithout finishing?`"
          buttonTextLeft="Confirm"
          :isCloseModal="false"
          @clickButtonLeft="clickConfirmCancelAddAddCommunity"
          @clickButtonRight="clickBackToModalAddCommunity"
        ></molecule-modal-dialog>
      </section>
    </section>
    <!-- ADD NEW SNMP COMMUNITY END -->

    <!-- ADD NEW SSH CREDENTIALS START -->
    <section name="add-credential">
      <molecule-modal-dialog
        modalId="credential__add-credential"
        :isTextCenter="true"
        textTitle="Add New SSH Credentials"
        buttonTextLeft="Add Credentials"
        :isSlotBody="true"
        :isDisableButtonLeft="isDisableButtonAddCredential"
        @clickButtonLeft="clickAddCredential"
        @clickButtonRight="clickCancelAddCredential"
      >
        <template #body>
          <div class="w-100 p-2 body__height">
            <div class="row">
              <div class="col-8">
                <atom-input
                  v-model="addCredential.name"
                  title="Credential Name"
                  placeholder="Credential Name"
                  :isAsterisk="true"
                  :isError="isErrorCredentialInput.name"
                  errorMessage="Please enter name"
                ></atom-input>
              </div>

              <div class="col-4 pl-1">
                <atom-input
                  v-model="addCredential.port"
                  title="Port"
                  placeholder="Port"
                  :isAsterisk="true"
                  :isError="isErrorCredentialInput.port"
                  type="number"
                ></atom-input>
              </div>
            </div>

            <atom-text-area
              v-model="addCredential.description"
              title="Description"
              placeholder="Credential Description"
              :rows="3"
              class="mt-1"
            ></atom-text-area>

            <div class="mt-2">
              <div class="text__title">
                Resource Type<label class="text__asterisk">*</label>
              </div>
              <div class="d-flex">
                <molecule-radio-select-data
                  v-for="(option, index) in resourceTypeOptions"
                  :key="index"
                  :radioOption="option"
                  :isAsterisk="true"
                  :selectedRadio="addCredential.type"
                  @selected="selectedType"
                >
                </molecule-radio-select-data>
              </div>
            </div>

            <atom-input
              v-model="addCredential.username"
              title="Username"
              placeholder="Username"
              :isAsterisk="true"
              :isError="isErrorCredentialInput.username"
              class="mt-2"
            ></atom-input>

            <atom-input
              v-model="addCredential.password"
              title="Password"
              placeholder="Password"
              :isAsterisk="true"
              :isError="isErrorCredentialInput.password"
              type="password"
              class="mt-1"
            ></atom-input>

            <atom-input
              v-model="addCredential.prompt"
              title="Prompt"
              placeholder=">"
              :isAsterisk="true"
              :isError="isErrorCredentialInput.prompt"
              class="mt-1"
            ></atom-input>

            <div class="d-flex justify-content-end mt-2">
              <atom-switch
                v-model="addCredential.isEnableRequired"
                title="Enable Required"
              ></atom-switch>
            </div>

            <div v-if="addCredential.isEnableRequired">
              <atom-input
                v-model="addCredential.enableCommand"
                title="Enable Command"
                placeholder="enable"
                class="mt-1"
              ></atom-input>

              <atom-input
                v-model="addCredential.enablePrompt"
                title="Enable Prompt"
                placeholder="#"
                class="mt-1"
              ></atom-input>

              <atom-input
                v-model="addCredential.enablePassword"
                title="Enable Password"
                placeholder="Enable Password"
                type="password"
                class="mt-1"
              ></atom-input>
            </div>
          </div>
        </template>
      </molecule-modal-dialog>

      <section name="modal-confirm-add-credential">
        <molecule-modal-dialog
          modalId="credential__confirm-add-credential"
          :isTextCenter="true"
          :textTitle="`Do you want to add\n“${addCredential.name}” ?`"
          buttonTextLeft="Confirm"
          @clickButtonLeft="clickConfirmAddCredential"
          @clickButtonRight="clickBackToModalAddCredential"
        ></molecule-modal-dialog>
        <molecule-modal-dialog
          modalId="credential__confirm-cancel-add-credential"
          :isTextCenter="true"
          :textTitle="`Do you want to leave\nwithout finishing?`"
          buttonTextLeft="Confirm"
          :isCloseModal="false"
          @clickButtonLeft="clickConfirmCancelAddAddCredential"
          @clickButtonRight="clickBackToModalAddCredential"
        ></molecule-modal-dialog>
      </section>
    </section>
    <!-- ADD NEW SSH CREDENTIALS END -->
  </div>
</template>

<script>
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import MoleculeRadioSelectData from "@/components/molecules/MoleculeRadioSelectData.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"

export default {
  name: "OrganismAddCredential",
  components: {
    MoleculeModalDialog,
    AtomInput,
    AtomTextArea,
    MoleculeRadioSelectData,
    AtomSwitch,
  },
  prop: {
    modalId: {
      type: String | null,
      require: true,
    },
    communityDetail: {
      type: Object,
    },
  },
  emits: ["addCommunity", "addCredential"],
  data() {
    return {
      modalId: null,

      /* COMMUNITY START */
      addCommunity: {
        name: null,
        port: "161",
        description: "",
        communityString: null,
      },
      isValidateCommunity: false,
      isErrorCommunityInput: {
        name: false,
        port: false,
        communityString: false,
      },
      /* COMMUNITY END */

      /* CREDENTIAL START */
      resourceTypeOptions: [
        {
          id: "SSH_V2",
          topic: "SSH V2",
        },
        {
          id: "TELNET",
          topic: "Telnet",
        },
      ],
      addCredential: {
        name: null,
        port: "22",
        description: "",
        type: null,
        username: null,
        password: null,
        prompt: null,
        isEnableRequired: false,
        enableCommand: null,
        enablePrompt: null,
        enablePassword: null,
      },
      isValidateCredential: false,
      isErrorCredentialInput: {
        name: false,
        port: false,
        username: false,
        password: false,
        prompt: false,
      },
      /* CREDENTIAL END */
    }
  },
  computed: {
    /* COMMUNITY START */
    isErrorCommunity() {
      return (
        this.isValidateCommunity &&
        (this.isErrorCommunityInput.name ||
          this.isErrorCommunityInput.port ||
          this.isErrorCommunityInput.communityString)
      )
    },
    isDisableButtonAddCommunity() {
      return this.isValidateCommunity && this.isErrorCommunity
    },
    /* COMMUNITY END */

    /* CREDENTIAL START */
    isErrorCredential() {
      return (
        this.isValidateCredential &&
        (this.isErrorCredentialInput.name ||
          this.isErrorCredentialInput.port ||
          this.isErrorCredentialInput.password ||
          this.isErrorCredentialInput.prompt)
      )
    },
    isDisableButtonAddCredential() {
      return this.isValidateCredential && this.isErrorCredential
    },
    /* CREDENTIAL END */
  },
  watch: {
    addCommunity: {
      deep: true,
      handler() {
        if (this.isValidateCommunity) this.validateAddCommunity()
      },
    },
    addCredential: {
      deep: true,
      handler() {
        if (this.isValidateCredential) this.validateAddCredential()

        if (this.addCredential.type)
          this.addCredential.port =
            this.addCredential.type.id === "SSH_V2" ? 22 : 23
      },
    },
  },
  created() {
    this.addCredential.type = this.resourceTypeOptions[0]
  },
  methods: {
    /* COMMUNITY START */
    clickAddCommunity() {
      this.isValidateCommunity = true
      this.validateAddCommunity()

      if (!this.isErrorCommunity) {
        this.closeModal("credential__add-community")
        this.openModal("credential__confirm-add-community")
      }
    },
    clickConfirmAddCommunity() {
      const addCommunity = {
        credentialName: this.addCommunity.name,
        credentialDescription: this.addCommunity.description,
        communityString: this.addCommunity.communityString,
        port: this.addCommunity.port,
      }

      this.$emit("addCommunity", addCommunity)

      this.closeModal()
      this.setAddCommunityToOrigin()
    },
    clickCancelAddCommunity() {
      this.closeModal("credential__add-community")
      this.openModal("credential__confirm-cancel-add-community")
    },
    clickBackToModalAddCommunity() {
      this.closeModal()
      this.openModal("credential__add-community")
    },
    clickConfirmCancelAddAddCommunity() {
      this.closeModal()
      this.setAddCommunityToOrigin()
    },
    setAddCommunityToOrigin() {
      this.addCommunity = {
        name: null,
        port: "161",
        description: "",
        communityString: null,
      }
      this.isValidateCommunity = false
      this.isErrorCommunityInput = {
        name: false,
        port: false,
        communityString: false,
      }
    },
    validateAddCommunity() {
      this.isErrorCommunityInput = this.validateCommunity(this.addCommunity)
    },
    /* COMMUNITY END */

    /* CREDENTIAL START */
    selectedType(type) {
      this.addCredential.type = type
    },
    clickAddCredential() {
      this.isValidateCredential = true
      this.validateAddCredential()

      if (!this.isErrorCredential) {
        this.closeModal("credential__add-credential")
        this.openModal("credential__confirm-add-credential")
      }
    },
    clickConfirmAddCredential() {
      const addCredential = {
        credentialName: this.addCredential.name,
        credentialDescription: this.addCredential.description,
        credentialProtocol: this.addCredential.type.id,
        username: this.addCredential.username,
        password: this.addCredential.password,
        prompt: this.addCredential.prompt,
        enableRequired: this.addCredential.isEnableRequired,
        enableCommand: this.addCredential.enableCommand,
        enablePrompt: this.addCredential.enablePrompt,
        enablePassword: this.addCredential.enablePassword,
        port: this.addCredential.port,
      }

      this.$emit("addCredential", addCredential)

      this.closeModal()
      this.setAddCredentialToOrigin()
    },
    clickCancelAddCredential() {
      this.closeModal("credential__add-credential")
      this.openModal("credential__confirm-cancel-add-credential")
    },
    clickBackToModalAddCredential() {
      this.closeModal()
      this.openModal("credential__add-credential")
    },
    clickConfirmCancelAddAddCredential() {
      this.closeModal()
      this.setAddCredentialToOrigin()
    },
    setAddCredentialToOrigin() {
      this.addCredential = {
        name: null,
        port: "161",
        description: "",
        type: this.resourceTypeOptions[0],
        username: null,
        password: null,
        prompt: null,
        isEnableRequired: false,
        enableCommand: null,
        enablePrompt: null,
        enablePassword: null,
      }
      this.isValidateCredential = false
      this.isErrorCredentialInput = {
        name: false,
        port: false,
        description: false,
      }
    },
    validateAddCredential() {
      this.isErrorCredentialInput = this.validateCredential(this.addCredential)
    },
    /* CREDENTIAL END */

    /* MODAL START */
    openModal(id) {
      if (this.modalId) this.closeModal()

      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    closeModal(id) {
      if (!id) id = this.modalId

      this.$bvModal.hide(id)
      this.modalId = null
    },
    /* MODAL END */

    /* VALIDATE START */
    validateCommunity({ name, port, communityString }) {
      return {
        name: this.checkEmptyString(name),
        port: this.checkRegExPort(port),
        communityString: this.checkEmptyString(communityString),
      }
    },

    validateCredential({ name, port, username, password, prompt }) {
      return {
        name: this.checkEmptyString(name),
        port: this.checkRegExPort(port),
        username: this.checkEmptyString(username),
        password: this.checkEmptyString(password),
        prompt: this.checkEmptyString(prompt),
      }
    },

    checkEmptyString(string) {
      return !string
    },
    checkRegExPort(port) {
      return !/^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/.test(
        port
      )
    },
    /* VALIDATE END */
  },
}
</script>

<style lang="scss" scoped>
.text__title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}

.text__asterisk {
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 0;
}

.body__height {
  max-height: calc(100vh - 20rem);
  overflow-y: auto;
}
</style>
